import {FreeSpinsIntroState} from '@fantasmagames/slot/src/modules/freespins/intro/states/FreeSpinsIntroState';
import {FreeSpinsEvents} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsEvents';

export class FreeSpinsRestoreIntroState extends FreeSpinsIntroState {
	public onEnterState(): void {
		this.view.setFreeSpinsAmount(this.module.logic.freeSpinsLeft);
		this.view.startFreeSpinsRestoredIntro();
		this.module.logic.startFreeSpinsIntro();
		this.emit(FreeSpinsEvents.FREE_SPINS_RESTORE_INTRO_STARTED);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/freespins/intro/states/FreeSpinsRestoreIntroState.ts